import { render, staticRenderFns } from "./SideOrderForm.vue?vue&type=template&id=0c665d60&scoped=true&"
import script from "./SideOrderForm.vue?vue&type=script&lang=js&"
export * from "./SideOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c665d60",
  null
  
)

export default component.exports